import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { GetSingleMading, reset } from "../../../features/mading/MadingSlice";

import { Card, Image } from "@themesberg/react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import ReactLogo from "../../../assets/img/technologies/react-logo-transparent.svg";

const ViewMadingPage = () => {
  const [dataMading, setDataMading] = useState({});

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.mading);

  const { slug } = useParams();
  const token = localStorage.getItem("token");

  // on init (call once when the page has been loaded)
  useEffect(() => {
    // call api to fetch fakultas dropdown data
    dispatch(reset());
    if (slug) {
      dispatch(GetSingleMading({ slug, token }));
    }
  }, [slug, dispatch, token]);

  // init the model before send to Server, if any.
  // update the model if user role is meant for "MAHASISWA".
  useEffect(() => {
    const copyData = Object.assign({ ...data?.data });
    setDataMading(copyData);
  }, [data]);

  return isLoading ? (
    <div className={`preloader bg-soft justify-content-center`}>
      <Image
        className="loader-element animate__animated animate__jackInTheBox"
        src={ReactLogo}
        height={40}
      />
    </div>
  ) : (
    <div style={{ maxWidth: "600px", margin: "0 auto" }}>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <h4>{dataMading.title}</h4>
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Body>
          <p style={{ color: "#a9a9a9" }}>
            <FontAwesomeIcon icon={faClock} className="me-2" />
            {moment(dataMading.created_at).format("DD MMM YYYY HH:mm:ss")}
          </p>
          <div dangerouslySetInnerHTML={{ __html: dataMading.content }} />
        </Card.Body>
      </Card>
      <center>
        <p style={{ color: "#a8a8a8" }}>
          &copy; Fakultas Teknik Dr. Soetomo 2024
        </p>
        <Link to={`/dashboard`}>
          SILANG
        </Link>
      </center>
    </div>
  );
};

export default ViewMadingPage;
